const editCookiesPoliciesConstantsEn = {
  cookiesPolicyPageTitle: 'Cookies Policy',
};

export default editCookiesPoliciesConstantsEn;
